import script from "./MonitoringLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoringLinks.vue?vue&type=script&setup=true&lang=js"

import "./MonitoringLinks.vue?vue&type=style&index=0&id=997176ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-997176ee"]])

export default __exports__